import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "15",
      cy: "15",
      r: "2"
    }, null, -1 /* CACHED */),
    _createElementVNode("ellipse", {
      cx: "15",
      cy: "15",
      rx: "11.5",
      ry: "4.5",
      transform: "rotate(45 15 15)"
    }, null, -1 /* CACHED */),
    _createElementVNode("ellipse", {
      cx: "15",
      cy: "15",
      rx: "11.5",
      ry: "4.5",
      transform: "rotate(-45 15 15)"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }